import React, { useEffect, useState } from 'react'
import axios from 'axios'
import API_BASE_URL from '../../../../config/api'
import Cookies from 'js-cookie'
import Topbar from '../../mini-comp/Topbar'
import Sidebar from '../../mini-comp/Sidebar'
import Swal from 'sweetalert2'
import { RiEyeLine, RiCheckLine, RiCloseLine } from 'react-icons/ri'

const LeaveRequests = () => {
    const [leaves, setLeaves] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchLeaves = async () => {
        try {
            const token = Cookies.get('token')
            const response = await axios.get(`${API_BASE_URL}/api/v1/leave/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            setLeaves(response.data)
            setLoading(false)
        } catch (error) {
            console.error('Error fetching leave requests:', error)
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchLeaves()
    }, [])

    const handleStatusUpdate = async (id, status) => {
        let response_message = ''

        if (status === 'rejected') {
            const { value: text, isDismissed } = await Swal.fire({
                title: 'Reject Leave Request',
                input: 'textarea',
                inputLabel: 'Reason for rejection',
                inputPlaceholder: 'Enter your message here...',
                inputAttributes: {
                    'aria-label': 'Enter your message here'
                },
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Submit Rejection'
            })

            if (isDismissed) return
            if (!text) {
                Swal.fire('Error', 'Please provide a rejection reason', 'error')
                return
            }
            response_message = text
        } else {
            const result = await Swal.fire({
                title: 'Approve Leave Request?',
                text: "You are about to approve this leave request.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, approve it!'
            })
            if (!result.isConfirmed) return
        }

        try {
            const token = Cookies.get('token')
            await axios.patch(`${API_BASE_URL}/api/v1/leave/${id}/`, {
                status: status,
                response_message: response_message
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            })

            Swal.fire(
                status === 'approved' ? 'Approved!' : 'Rejected!',
                `The leave request has been ${status}.`,
                'success'
            )
            fetchLeaves()
        } catch (error) {
            console.error(`Error ${status} leave request:`, error)
            Swal.fire('Error', `Failed to ${status} leave request.`, 'error')
        }
    }

    const formatDate = (dateString) => {
        if (!dateString) return ''
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        })
    }

    const getStatusBadgeClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved': return 'bg-label-success'
            case 'rejected': return 'bg-label-danger'
            case 'pending': return 'bg-label-warning'
            default: return 'bg-label-primary'
        }
    }

    const handleViewDetails = (leave) => {
        Swal.fire({
            title: 'Leave Request Details',
            html: `
                <div class="text-start fs-14">
                    <p><strong>Employee:</strong> ${leave.employee_name || 'N/A'} (${leave.employee_id || ''})</p>
                    <p><strong>Leave Type:</strong> ${leave.leave_type_name || leave.leave_type || 'N/A'}</p>
                    <p><strong>Start Date:</strong> ${formatDate(leave.start_date)}</p>
                    <p><strong>End Date:</strong> ${formatDate(leave.end_date)}</p>
                    <p><strong>Duration:</strong> ${leave.duration} days</p>
                    <p><strong>Reason:</strong> ${leave.reason || 'No reason provided'}</p>
                    <p><strong>Status:</strong> <span class="badge ${getStatusBadgeClass(leave.status)}">${leave.status}</span></p>
                    ${leave.response_message ? `<p><strong>Manager Response:</strong> ${leave.response_message}</p>` : ''}
                </div>
            `,
            confirmButtonText: 'Close',
            customClass: {
                confirmButton: 'btn btn-primary'
            }
        })
    }

    return (
        <div>
            <Topbar />
            <Sidebar />

            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-header justify-between">
                                        <h4 className="d-flex-items gap-10">Employee Leave Requests <span className="badge bg-label-primary">{leaves.length}</span></h4>
                                    </div>
                                    <div className="card-body pt-15">
                                        <div className="table-responsive">
                                            <table className="table w-100 text-nowrap" id="employeeAttendanceTable">
                                                <thead>
                                                    <tr>
                                                        <th>Employee</th>
                                                        <th>Leave Type</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Duration</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <tr>
                                                            <td colSpan="7" className="text-center py-4">
                                                                <div className="spinner-border text-primary" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : leaves.length > 0 ? (
                                                        leaves.map((leave) => (
                                                            <tr key={leave.id}>
                                                                <td>
                                                                    <div className="d-flex-items gap-10">
                                                                        <div>
                                                                            <h6>{leave.employee_name || 'N/A'}</h6>
                                                                            <span className="text-muted fs-12">{leave.employee_id || ''}</span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{leave.leave_type_name || leave.leave_type || 'N/A'}</td>
                                                                <td>{formatDate(leave.start_date)}</td>
                                                                <td>{formatDate(leave.end_date)}</td>
                                                                <td>{leave.duration}</td>
                                                                <td>
                                                                    <span className={`badge ${getStatusBadgeClass(leave.status)}`}>
                                                                        {leave.status}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex-items gap-10">
                                                                        {leave.status?.toLowerCase() === 'pending' && (
                                                                            <>
                                                                                <button
                                                                                    className="btn-icon btn-success-light"
                                                                                    title="Approve"
                                                                                    onClick={() => handleStatusUpdate(leave.id, 'approved')}
                                                                                >
                                                                                    <RiCheckLine />
                                                                                </button>
                                                                                <button
                                                                                    className="btn-icon btn-danger-light"
                                                                                    title="Reject"
                                                                                    onClick={() => handleStatusUpdate(leave.id, 'rejected')}
                                                                                >
                                                                                    <RiCloseLine />
                                                                                </button>
                                                                            </>
                                                                        )}
                                                                        <button
                                                                            className="btn-icon btn-info-light"
                                                                            title="View Details"
                                                                            onClick={() => handleViewDetails(leave)}
                                                                        >
                                                                            <RiEyeLine />
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center py-4">No leave requests found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LeaveRequests
